import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { SMILES_VERIFICATION_PATH } from '@/src/constants/smiles'
import type { SmilesVerificationStatus } from '@/src/types/smiles'
import setCommonHeaders from '@/src/utils/rtkQuery/setCommonHeaders'

export interface VerifySmilesUserArgs {
    accountNumber: string
    accessToken: string
    partnerId: string
}

export interface SmilesVerificationResult {
    status: SmilesVerificationStatus
    accountNumber: string
}

interface SmilesVerificationResponse {
    status?: string
    message?: string
}

export const smilesApi = createApi({
    reducerPath: 'smilesApi',
    baseQuery: fetchBaseQuery({
        credentials: 'include',
        prepareHeaders: headers => setCommonHeaders(headers)
    }),
    endpoints: builder => ({
        verifySmilesUser: builder.mutation<SmilesVerificationResult, VerifySmilesUserArgs>({
            query: ({ accountNumber, accessToken, partnerId }) => ({
                // Token duplicated in the query string per the upstream contract; the body is what the backend reads.
                url: `${SMILES_VERIFICATION_PATH}?partner_id=${encodeURIComponent(
                    partnerId
                )}&accessToken=${encodeURIComponent(accessToken)}`,
                method: 'POST',
                body: { accountNumber, accessToken }
            }),
            transformResponse: (response: SmilesVerificationResponse, _meta, arg) => ({
                status: response?.status === 'SUCCESS' ? 'SUCCESS' : 'FAILURE',
                accountNumber: arg.accountNumber
            }),
            transformErrorResponse: (): SmilesVerificationResult => ({
                status: 'FAILURE',
                accountNumber: ''
            })
        })
    })
})

export const { useVerifySmilesUserMutation } = smilesApi
export default smilesApi
